module.exports = __webpack_public_path__ + "img/fank1.64fd8591.png";